import { UserInfo } from "@/sources/kicker-ovsyndication";
import Bugsnag from "@bugsnag/js";

export function getSsoProfileFullName(ssoProfile: UserInfo | null) {
  if (!ssoProfile || !(ssoProfile.firstName && ssoProfile.lastName)) {
    return ssoProfile?.displayName;
  }

  return [ssoProfile.firstName, ssoProfile.lastName].join(" ");
}

export function getSsoProfileFirstName(ssoProfile: UserInfo | null) {
  if (!ssoProfile || !ssoProfile.firstName) {
    return ssoProfile?.displayName;
  }

  return ssoProfile.firstName;
}

export function parseSSOProfileLists(parsedDataArray: UserInfo[]): {
  [amaPersonId: number]: boolean;
} {
  try {
    const personObject: { [amaPersonId: number]: boolean } = {};

    parsedDataArray.forEach((profile) => {
      // console.log("profile", JSON.stringify(profile, null, 2));
      if (profile.persons) {
        profile.persons.map(person => personObject[person.personId] = true)
      }
    });

    return personObject;
  } catch (error) {
    console.error("An error occurred:", error);
    Bugsnag.notify(error as Error);
    return {};
  }
}
